import { timePeriodFactory } from './categories';

const timePeriodReducer = (timePeriod, action) => {
    const { raceType, countryCode } = timePeriod.createdBy;

    if (action.type === 'raceType' && raceType !== action.value) {
        return timePeriodFactory(action.value, countryCode);
    }

    return timePeriod;
};

const categoriesReducer = ({ raceType, timePeriod }, action) => ({
    raceType,
    timePeriod: timePeriodReducer(timePeriod, action),
});

export default categoriesReducer;



// WEBPACK FOOTER //
// ./src/js/course/favourites/reducer.js